<template>
    <card-seplag :titulo="nomeCard">
        <div class="p-col-12 p-component p-fieldset" style="margin-bottom: 1%;">            
            <div class="p-grid" style="padding-left: 1%;">                
                <div class="p-col-1 col-imagem">
                    <i class="pi pi-user iconIdentificacaoForm"></i>
                </div>
                <div class="p-col-md-11 p-col-sm-12" style="margin-top: 1%;">
                    <p><strong>{{ dadosPessoa.nome }}</strong></p>
                    <p><strong>Matrícula:</strong> {{ dadosPessoa.matricula }}</p>
                    <p><strong>CPF:</strong> {{ dadosPessoa.cpfFormatado }}</p>
                    <p><strong>RG:</strong> {{ dadosPessoa.rg }}</p>
                </div>
            </div>
        </div>     
        <Rotulo nome="Email:" cols="12 4" requerido>
            <InputText type="text" id="descEmail" v-model="registro.descEmail" :disabled="naoPodeEditar" />
        </Rotulo>
        <Rotulo nome="Contato com WhatsApp" cols="12 2" requerido>
            <InputMask id="descTelefoneWhatsapp" mask="(99)9 9999-9999" v-model="registro.descTelefoneWhatsapp" :disabled="naoPodeEditar"/>
        </Rotulo>
        <Rotulo nome="Contato" cols="12 2">
            <InputMask id="descTelefone" mask="(99)9 9999-9999" v-model="registro.descTelefone" :disabled="naoPodeEditar"/>
        </Rotulo>
        <Divider class="p-col-12" style="border: 1px solid #d5d5d5;"/>   
        <h3 class="p-col-12">DADOS BANCÁRIOS PARA PAGAMENTO:</h3>
        <Rotulo nome="Banco:" cols="12 4" requerido>
            <InputText type="text" id="conta" v-model="dadosBancarios.banco" disabled />
        </Rotulo>    
        <Rotulo nome="Agencia:" cols="12 4" requerido>
            <InputText type="text" id="agencia" v-model="dadosBancarios.agencia" disabled />
        </Rotulo>
        <Rotulo nome="Conta:" cols="12 4" requerido>
            <InputText type="text" id="conta" v-model="dadosBancarios.conta" disabled />
        </Rotulo>    
        <p class="p-col-12"><strong>Observação:</strong> Caso seus dados bancários estejam <strong>incorretos, ainda assim, clique em “Solicitar”</strong> para finalizar o requerimento, mas não deixe de comparecer à SEDUC ou à qualquer unidade escolar da rede estadual para indicar conta bancária corrente ou salário do Banco do Brasil de sua titularidade, munido de documentos pessoais para comprovação, sob risco de não receber sua indenização no prazo acordado.</p>
        <Divider class="p-col-12" style="border: 1px solid #d5d5d5;"/>
        <div class="p-col-12 p-md-3 divBotoesFinais">
            <Button label="Voltar" icon="pi pi-arrow-left" @click="voltarParaLista" class="p-button-text"/>
            <Button label="Solicitar" icon="pi pi-save" @click="abrirTermoAceite" autofocus />
        </div>
        <Dialog header="Atenção!!" :visible.sync="visualizarModalAceito" :containerStyle="{width: '55vw'}" :modal="true">
            <div style="display: flex;flex-wrap: wrap;">
                <p class="m-0" style="font-size: larger;width: 100%;margin: 5px;">Confira <b>CUIDADOSAMENTE</b> os dados bancários para recebimento da indenização:</p>
                <p class="m-0" style="font-size: larger;width: 100%;margin: 5px;"><strong>BANCO:</strong> {{ dadosBancarios.banco }}<br/><strong>AGENCIA:</strong> {{ dadosBancarios.agencia }}<br /> <strong>CONTA:</strong> {{ dadosBancarios.conta }} </p>
                <p class="m-0" style="font-size: larger;width: 100%;margin: 5px;"><strong>Observação:</strong> Caso seus dados bancários estejam <strong>incorretos, ainda assim, clique em “Solicitar”</strong> para finalizar o requerimento, mas não deixe de comparecer à SEDUC ou à qualquer unidade escolar da rede estadual para indicar conta bancária corrente ou salário do Banco do Brasil de sua titularidade, munido de documentos pessoais para comprovação, sob risco de não receber sua indenização no prazo acordado.</p>
            </div>
            <template #footer>
                <Button label="Fechar" icon="pi pi-times" @click="fecharModal" class="p-button-text"/>
                <Button label="Ciente" icon="pi pi-check" @click="gravarSolicitacao" autofocus />
            </template>
        </Dialog>
    </card-seplag>  
</template>

<script>
import CardSeplag from "@/template/CardSeplag.vue";
import Rotulo from "@/template/RotuloSeplag.vue";
import { baseApiUrl } from "@/config/global";
import moment from "moment";
const getNovoForm = () => {
    return {
        dataSolicitacaoVerbaResc: null,
        numrMatricula: null,
        descEmail: '',
        nomeSolicitante: null,
        descTelefoneWhatsapp: '',
        flagPossuiProcesso: null,
        flagSolicitacaoVerbaResc: null,
        solicitacaoDespachoProposta: null,
        dataAceiteVerbaResc: null,
        solicitacaoVerbaProcessoList: [],
        solicitacaoDespachoList: []
    }
}
const getNovoProcesso = () => {
    return {
        idenSolicitacaoVerbaProces: null,
        descProcesso: null,
        flagRecebeuValor: null,
        valrRecebido: null,
        statProcesso: null,
        descObjetoAcao: null,
        flagOrigem: 1,
        code: 1
    }
}
export default {
    name: "solicitaVerbaForm",
    components: { CardSeplag, Rotulo },
    data() {
        return {
            modo:"NOVO",
            naoPodeEditar: false,
            visualizarModalProcesso: false,
            visualizarModalAceito: false,
            dadosPessoa: {
                    matricula: null,
                    vinculo: null,
                    cpf: null,
                    rg: null,
                    nome: null,
                    cpfFormatado:null,
            },
            idenSolicitacao: null,
            idenVinculo: null,
            valorCalculado: 0,
            listaValorCalculado: [],
            nomeCard:"Nova Solicitação de Verba Indenizatória",
            registro: getNovoForm(),
            processo: getNovoProcesso(),
            despacho: null,
            listaObjetoAcao: [
                {code: "FERIAS", name:"Férias"},
                {code: "FERIAS_ADICIONAL_FERIAS", name:"Férias + Adicional de Férias"},
                {code: "FERIAS_FGTS", name:"Férias + FGTS"},
            ],
            dadosBancarios:{
                agencia:"",
                conta:"",
                banco:""
            }
        }
    },
    methods: {
        carregarDados(){
            if(this.$store.getters.getUser){            
                this.dadosPessoa = {
                    matricula:  this.$store.getters.getMatricula,
                    vinculo: this.$store.getters.getVinculo,
                    cpf: this.$store.getters.getUser.dadosUsuariosCustomizados.pessoa.documentosPessoais.cpf,
                    rg: this.$store.getters.getUser.dadosUsuariosCustomizados.pessoa.documentosPessoais.rg,
                    nome: this.$store.getters.getUser.dadosUsuariosCustomizados.pessoa.nome,
                    cpfFormatado: this.$store.getters.getUser.dadosUsuariosCustomizados.pessoa.documentosPessoais.cpfFormatado,
                };
                for(let i=0; i<this.$store.getters.getUser.contaAcesso.listaVinculo.length; i++){
                    if(this.$store.getters.getUser.contaAcesso.listaVinculo[i].numrVinculo == this.$store.getters.getUser.dadosUsuariosCustomizados.vinculoSeap.vinculo){
                    this.idenVinculo = this.$store.getters.getUser.contaAcesso.listaVinculo[i].idenVinculo;
                    break;
                    }
                }
            }
            let query = this.$route.query;   
            if(query.id){    
                this.idenSolicitacao = query.id;             
                this.$http.get(`${baseApiUrl}/solicitacoes-verba-rescisoria/${query.id}`).then((res) => {
                    this.registro = res.data.map(function (element) {
                        return {
                            ...element,
                            flagPossuiProcesso: element.solicitacaoVerbaProcessoList.length>0? 1:0
                        };
                        });
                });
            }  
            
            this.$http.get(`${baseApiUrl}/dados-bancarios/${this.$store.getters.getMatricula}`).then((res2) => {
                this.dadosBancarios = res2.data
            })                  
        },
        voltarParaLista(){
            this.$router.push({name:"solicitaVerba"});
        },
        fecharModal(){
            this.visualizarModalAceito = false;
            this.visualizarModalProcesso = false;
        },
        novoProcesso(){
            this.modo = "NOVO"
            this.processo = getNovoProcesso();
            if( this.registro.solicitacaoVerbaProcessoList.length > 0){
                this.processo.code =  this.registro.solicitacaoVerbaProcessoList.length+1;
            }
            this.visualizarModalProcesso = true;
        },
        editarProcesso(data){  
            this.modo = "EDITAR"          
            if(data.idenSolicitacaoVerbaProces==null){
                this.processo = data;
                this.visualizarModalProcesso = true;
            }else{
                this.$toast.add({
                severity: "error",
                summary:
                    "Não é permitido Editar Após solicitar Idenização",
                life: 3000,
                });
            }
        },
        cadastrarNovoProcesso(){
            if(this.modo == "NOVO"){
                this.registro.solicitacaoVerbaProcessoList.push(this.processo);
            }
            this.fecharModal();
        },
        deletarProcesso(processo){
            if(processo.idenSolicitacaoVerbaProces==null){
                this.registro.solicitacaoVerbaProcessoList = this.registro.solicitacaoVerbaProcessoList.filter(element=>{
                    return element.code != processo.code
                })
                let codeNum = 0 ;
                this.registro.solicitacaoVerbaProcessoList = this.registro.solicitacaoVerbaProcessoList.map(function (element) {
                    codeNum = codeNum+1;
                    return {
                        ...element,
                        code: codeNum
                    };
                    }); 
            }else{
                this.$toast.add({
                severity: "error",
                summary:
                    "Não é permitido Deletar Após solicitar Idenização",
                life: 3000,
                });
            }
        },
        abrirTermoAceite(){
            this.visualizarModalAceito = true;
        },
        gravarSolicitacao(){
            if(this.registro.descEmail == '' || this.registro.descTelefoneWhatsapp == ''){                
                this.$toast.add({
                severity: "error",
                summary:
                    "Telefone e E-mail são itens de preenchimento obrigatório.",
                life: 3000,
                });
                this.fecharModal()
            }else {
                if(!this.validarEmail()){               
                    this.$toast.add({
                        severity: "error",
                        summary: "E-mail cadastrado não é invalido.",
                        life: 3000,
                    });
                    this.fecharModal()
                    return
                }
                this.$http.post(`${baseApiUrl}/parametro/busca`,JSON.stringify({
                    busca: "PRAZO_LIMITE_SOLICITACOES",
                    idenSistema: process.env.VUE_APP_CODIGO_SISTEMA,
                    })
                )
                .then((res2) => {                    
                    if (res2.data.totalElements > 0) {                      
                      this.parametroPrazo = res2.data.content[0];                      
                      let dataLimite = new moment(res2.data.content[0].valorParametro, "DD/MM/YYYY")
                      if(moment().isAfter(dataLimite)){
                        this.$toast.add({
                            severity: "error",
                            summary:
                                "Prazo para solicitação de verba indenizatória expirado.",
                            life: 3000,
                        });
                        this.voltarParaLista();
                        return
                      }
                    }else{
                        this.$toast.add({
                            severity: "error",
                            summary:
                                "Prazo para solicitação de verba indenizatória não configurado.",
                            life: 3000,
                        });
                        this.voltarParaLista();
                        return
                    }
                });
                this.registro.numrMatricula = this.dadosPessoa.matricula
                this.registro.nomeSolicitante = this.dadosPessoa.nome
                this.registro.flagSolicitacaoVerbaResc = this.registro.solicitacaoVerbaProcessoList.length>0? 1 : 0
                this.registro.flagPossuiProcesso = 'N'
                this.$http.post(`${baseApiUrl}/solicitacoes-verba-rescisoria`,JSON.stringify(this.registro)).then(() => {
                    this.$toast.add({
                        severity: "success",
                        summary:
                            "Solicitação criada com sucesso. Porfavor Aguarde o tramite do processo.",
                        life: 3000,
                    });
                    this.voltarParaLista();
                });
            }
            
        },        
        applyMask() {
            let value = this.processo.descProcesso.replace(/\D/g, ''); // Remove tudo que não é número
            if(value.length == 16){            
                value = value.slice(0, 12);
            }
            // Aplica as partes da máscara manualmente
            if (value.length > 12) {
                value = value.slice(0, 7) + '-' + value.slice(7, 9) + '.' + value.slice(9, 13) + '.8.11.' + value.slice(16, 20);
            } else if (value.length > 9) {
                value = value.slice(0, 7) + '-' + value.slice(7, 9) + '.' + value.slice(9, 13);
            } else if (value.length > 7) {
                value = value.slice(0, 7) + '-' + value.slice(7,);
            } 
            this.processo.descProcesso = value;
        },
        validarEmail() {
            // Verifica se o campo está vazio
            if (!this.registro.descEmail) {
                return false;
            }
            // Expressão regular para validar o formato de um email
            const regexEmail = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

            // Verifica se o email é válido
            if (regexEmail.test(this.registro.descEmail)) {
                return true;
            } else {
                return false;
            }
        }
    },
    mounted() {
        this.carregarDados();
    },

}
</script>

<style scoped>
    .textoInformativoVerbaIdenizatoriaForm{
        line-height: 1.5;
        margin: 0;
        text-align: justify;
    }
    .iconIdentificacaoForm {
        font-size: 8em;
    }
    .divRadioButton{
        display: flex;
        flex-direction: row;
        align-items: center;
    }
    .divBotoesFinais{
        display: flex;
        flex-direction: row;
        flex-wrap: nowrap;
        align-items: center;
    }
</style>